import { jsx as x } from "react/jsx-runtime";
import { forwardRef as y, useMemo as S, cloneElement as v } from "react";
import { e as B } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as m } from "./tw-cn-mXgPecoF.mjs";
import { r as N } from "./rectangle-button.styles-BE1aDLeU.mjs";
import { c as r } from "./index-BpNK5r1N.mjs";
const I = r(["aspect-square p-4 "], {
  variants: {
    size: {
      xLarge: "min-h-56 rounded-16",
      large: "min-h-52 rounded-16",
      medium_plus: "min-h-44 rounded-12",
      medium: "min-h-40 rounded-12",
      small: "min-h-32 rounded-10"
    },
    pcSize: {
      xLarge: "pc:min-h-56 pc:rounded-16",
      large: "pc:min-h-52 pc:rounded-16",
      medium_plus: "pc:min-h-44 pc:rounded-12",
      medium: "pc:min-h-40 pc:rounded-12",
      small: "pc:min-h-32 pc:rounded-10"
    }
  }
}), L = r("", {
  variants: {
    size: {
      xLarge: "size-32",
      large: "size-24",
      medium_plus: "size-24",
      medium: "size-24",
      small: "size-20"
    },
    pcSize: {
      xLarge: "pc:size-32",
      large: "pc:size-24",
      medium_plus: "pc:size-24",
      medium: "pc:size-24",
      small: "pc:size-20"
    }
  }
}), _ = y(
  ({ theme: c = "filled_primary", disabled: i = !1, size: t, disabledType: a = "default", ...p }, l) => {
    const { children: u, type: d = "button", icon: e, className: z, ...f } = p, n = B({
      property: t,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "xLarge" }
    }), h = N({ theme: c, disabledType: a }), g = I({ ...n }), o = L({ ...n }), s = S(
      () => e ? v(e, {
        className: m(o, e.props.className)
      }) : null,
      [e, o]
    );
    return /* @__PURE__ */ x(
      "button",
      {
        "aria-disabled": i,
        className: m(h, g, z),
        disabled: i,
        ref: l,
        tabIndex: i ? -1 : 0,
        type: d,
        ...f,
        children: s || u
      }
    );
  }
);
_.displayName = "NDS.IconButton";
export {
  _ as I
};
